import { render, staticRenderFns } from "./DiseaseGroupSelect.vue?vue&type=template&id=dd6f1022"
import script from "./DiseaseGroupSelect.vue?vue&type=script&lang=js"
export * from "./DiseaseGroupSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Cancer Genetics - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd6f1022')) {
      api.createRecord('dd6f1022', component.options)
    } else {
      api.reload('dd6f1022', component.options)
    }
    module.hot.accept("./DiseaseGroupSelect.vue?vue&type=template&id=dd6f1022", function () {
      api.rerender('dd6f1022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiseaseGroupSelect.vue"
export default component.exports